export default __webpack_public_path__ + "static/media/background.b154c7f2.png";